import * as z from 'zod'

import { getLegalSchemaWithPreprocess } from '@flows/configs/shared/schemaPreprocessUtils'
import { BaseSchema_LegalBasis3BasicRolandDe as baseSchema } from '@flows/insurance/schemas'

/**
 * Schema that converts the flow data according to the format required by BE
 */
export const schema = getLegalSchemaWithPreprocess(
  baseSchema.merge(
    z.object({
      insurance_was_voided_before: baseSchema.shape.insurance_was_voided_before.default(false),
      legal_insurance_in_last_5y: baseSchema.shape.legal_insurance_in_last_5y.default(false),
    })
  )
)
